import React from "react";
import './App.css';
import DkNav from "./components/NavBar/navBar.jsx";
import Header from "./components/Header/header.jsx";
import Carosel from "./components/Carosel/carosel.jsx";
import Planos from "./components/Planos/planos-Lista.jsx";
import SobreNos from "./components/SobreNos/sobreNos.jsx";
import Localizacao from "./components/Localizacao/localizacao.jsx";
import FaleConosco from "./components/FaleConosco/faleConosco.jsx";
import GoogleReviews from "./components/GoogleReviews/googleReview.jsx";
import Footer from "./components/Footer/footer.jsx";

import logo from "../src/img/DkLogo-Preto.svg";

// Imagens para o carrossel Conheca nossos espaços
import Espacos01 from "../src/img/Auditorio01.png";
import Espacos02 from "../src/img/Auditorio02.jpg";
import Espacos03 from "../src/img/Auditorio03.jpg";
import Espacos04 from "../src/img/Auditorio04.jpg";
import Espacos05 from "../src/img/Auditorio05.jpg";
import Espaco06 from "../src/img/Estacao01.png";
import Espaco07 from "../src/img/Estacao02.png";
import Espaco08 from "../src/img/Fachada01.png";
import Espaco09 from "../src/img/Reuniao01.jpeg";
import Espaco10 from "../src/img/Reuniao02.jpg";
import Espaco11 from "../src/img/Reuniao03.jpeg";
import Espaco12 from "../src/img/Reuniao04.jpg";
import Espaco13 from "../src/img/Reuniao05.jpg";
import Espaco14 from "../src/img/SalaPrivativa01.jpg";
import Espaco15 from "../src/img/SalaPrivativa02.png";
import Espaco16 from "../src/img/SalaPrivativa03.jpg";


// Logos Parceiros
import parceiro01 from "../src/img/Parceiros/parceiros (1).png";
import parceiro02 from "../src/img/Parceiros/parceiros (2).png";
import parceiro03 from "../src/img/Parceiros/parceiros (3).png";
import parceiro04 from "../src/img/Parceiros/parceiros (4).png";
import parceiro05 from "../src/img/Parceiros/parceiros (5).png";
import parceiro06 from "../src/img/Parceiros/parceiros (6).png";
import parceiro07 from "../src/img/Parceiros/parceiros (7).png";
import parceiro08 from "../src/img/Parceiros/parceiros (8).png";
import parceiro09 from "../src/img/Parceiros/parceiros (9).png";
import parceiro11 from "../src/img/Parceiros/parceiros (11).png";
import parceiro12 from "../src/img/Parceiros/parceiros (12).png";
import parceiro13 from "../src/img/Parceiros/parceiros (13).png";
import parceiro14 from "../src/img/Parceiros/parceiros (14).png";


// Importando o widget de avaliações do Google
import GoogleReviewsWidget from "google-reviews-widget";



function App() {
  return (
    <div className="Home">
        <section id="home">
            <DkNav/>
        </section>
        <section id="header">
            <Header/>
        </section>
        <br></br>
        <section>
            <SobreNos/>
        </section>
        <section id="espaco">
            <h1 className="h1-Planos">Nossos espaços</h1>
            <Carosel 
              images={[
                Espacos01,
                Espacos02,
                Espacos03,
                Espacos04,
                Espacos05,
                Espaco06,
                Espaco07,
                Espaco08,
                Espaco09,
                Espaco10,
                Espaco11,
                Espaco12,
                Espaco13,
                Espaco14,
                Espaco15,
                Espaco16,
              ]}  
            />
        </section>
        <section id="localizacao">
          <h1 className="h1-Planos" >Localização privilegia</h1>
            <Localizacao/>
        </section>
        
        <section id="body-planos">
          <h1 className="h1-Planos" id="planos">Planos</h1>
            <Planos/>
        </section>
      <section id="reviews">
       <div className="review">
          <div className="logo-Review">
          <h1 className="h1-Review"> Clientes que confiam no </h1>
          <img className="logo-review" src={logo} alt="Logo DK Coworking"/>
          </div>    
          <GoogleReviews />
        </div>
      </section>
      <section>
          <FaleConosco/>
      </section>
      <section>
        <h1 className="h1-Planos" id="planos">Nossos Parceiros</h1>
          <Carosel 
              images={[
                parceiro01,
                parceiro02,
                parceiro03,
                parceiro04,
                parceiro05,
                parceiro06,
                parceiro07,
                parceiro08,
                parceiro09,
                parceiro11,
                parceiro12,
                parceiro13,
                parceiro14,     
              ]}  
            />   
      </section>        
      <br></br>
      <section>
        <Footer/>
      </section>
      </div>
  );
}
export default App;